import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../theme';

interface QuestionLabelProps {
  number?: number;
  children: React.ReactNode;
  hint?: React.ReactNode;
}

export const QuestionLabel: React.FC<QuestionLabelProps> = ({ number, children, hint }) => {

  return (
    <Box sx={{ marginBottom: '12px' }}>
      <Box sx={{ display: 'flex', gap: '4px' }}>
        {number !== undefined && (
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 600,
              color: colors.deepNavy,
              flexShrink: 0,
            }}
          >
            {number}.
          </Typography>
        )}
        <Typography
          sx={{
            fontSize: '1rem',
            fontWeight: 600,
            color: colors.deepNavy,
            marginBottom: hint ? '4px' : 0,
          }}
        >
          {children}
        </Typography>
      </Box>
      {hint && <Box sx={{ marginLeft: '20px' }}>{hint}</Box>}
    </Box>
  );
};
